var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.333328C5.57168 0.333328 0.333344 5.57166 0.333344 12C0.333344 18.4283 5.57168 23.6667 12 23.6667C18.4283 23.6667 23.6667 18.4283 23.6667 12C23.6667 5.57166 18.4283 0.333328 12 0.333328ZM15.92 14.6833C16.2583 15.0217 16.2583 15.5817 15.92 15.92C15.745 16.095 15.5233 16.1767 15.3017 16.1767C15.08 16.1767 14.8583 16.095 14.6833 15.92L12 13.2367L9.31668 15.92C9.14168 16.095 8.92001 16.1767 8.69834 16.1767C8.47668 16.1767 8.25501 16.095 8.08001 15.92C7.74168 15.5817 7.74168 15.0217 8.08001 14.6833L10.7633 12L8.08001 9.31666C7.74168 8.97833 7.74168 8.41833 8.08001 8.08C8.41834 7.74166 8.97834 7.74166 9.31668 8.08L12 10.7633L14.6833 8.08C15.0217 7.74166 15.5817 7.74166 15.92 8.08C16.2583 8.41833 16.2583 8.97833 15.92 9.31666L13.2367 12L15.92 14.6833Z",
    fill: "#E74242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.74f2b30008b08d752a78a4bc6ed91a18.svg";
export { ForwardRef as ReactComponent };